import React from "react";
import { Button } from "@/components/ui/button";
import { AnalyticsPeriod, periodLabel } from "@/utils/analyticsPeriod";

interface Props {
  value: AnalyticsPeriod;
  onChange: (p: AnalyticsPeriod) => void;
}

const OPTIONS: AnalyticsPeriod[] = ["today", "24h", "7d", "30d"];

const PeriodFilter: React.FC<Props> = ({ value, onChange }) => {
  return (
    <div className="flex flex-wrap gap-2">
      {OPTIONS.map((p) => (
        <Button
          key={p}
          size="sm"
          variant={value === p ? "default" : "outline"}
          onClick={() => onChange(p)}
        >
          {periodLabel(p)}
        </Button>
      ))}
    </div>
  );
};

export default PeriodFilter;
